import React from "react";
import { useT } from "@/i18n/useT";

export default function AnnouncementBar() {
  const t = useT();
  return (
    <div data-testid="announcement-bar" className="bg-espresso text-cream text-[11px] text-center py-2.5 px-4 font-sans tracking-[0.2em] uppercase">
      {t.announcement}
    </div>
  );
}